import React from 'react';
import { Helmet } from 'react-helmet';
import Layout from '@/components/Layout';
import SolarPvSystemPage from '@/components/solar-pv-system/SolarPvSystemPage';

const SolarPvSystem = () => {
  return (
    <>
      <Helmet>
        <title>EPC Builder</title>
        <meta name="description" content="Solar Pv System" />
      </Helmet>
      <Layout title="EPC Builder Solar Pv System">
        <SolarPvSystemPage />
      </Layout>
    </>
  );
};

export default SolarPvSystem;
